import { render, staticRenderFns } from "./innerPageNew.vue?vue&type=template&id=efda4d78&scoped=true&"
import script from "./innerPageNew.vue?vue&type=script&lang=js&"
export * from "./innerPageNew.vue?vue&type=script&lang=js&"
import style0 from "./innerPageNew.vue?vue&type=style&index=0&id=efda4d78&prod&lang=less&"
import style1 from "./innerPageNew.vue?vue&type=style&index=1&id=efda4d78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda4d78",
  null
  
)

export default component.exports